module.exports = __webpack_public_path__ + "static/media/facebooks-hooli-moment.13570bf4.md";